export default __webpack_public_path__ + "static/media/MicrosoftTeams-image3.f181191e.png";